/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { reportError } from 'helpers/error-logging';
import { isRedirectingToLogin as readRedirectFlag } from 'helpers/session-auth-redirect';
import InternalErrorComponent from '../InternalError';

class ComponentErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === 'test') {
      console.log(error);
    }

    // Suppress error reporting during the auth-redirect window: render crashes here are
    // expected fallout from the 401/403 that triggered the redirect, not real bugs.
    if (readRedirectFlag()) return;

    const { children } = this.props;
    const originalName = children?.displayName || children?.name || 'unknown component';
    reportError(`<ComponentErrorBoundary /> caught error in: ${originalName}`, error);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (!hasError) return children;

    // Avoid flashing the maintenance overlay while a logout redirect is in flight.
    if (readRedirectFlag()) return null;

    return <InternalErrorComponent />;
  }
}

export { ComponentErrorBoundary };
export default ComponentErrorBoundary;
